export const SET_DESTINATION_PATH = 'SET_DESTINATION_PATH';

export const GET_OPERATOR = 'GET_OPERATOR';

export const SAVE_PLAN_INFOS = 'SAVE_PLAN_INFOS';